import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid2";
import Divider from "@mui/material/Divider";
import SaveIcon from "@mui/icons-material/Save";
import {
  Typography,
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  ListItem,
  ListItemIcon,
  ListItemText,
  RadioGroup,
  Radio,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CheckIcon from "@mui/icons-material/Check";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import {
  isEmpty,
  validateActionItemName,
  validateDateFormat,
  validateText,
} from "../../../../../../utils/actionItemsValidation";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  selectAllUsers,
  selectUserData,
  selectUserDetails,
  selectUserToken,
  selectUserWebsitePermissions,
  setDisplayErrorSnackBar,
} from "../../../../../../features/userSlice";
import { ActionItemsEndPointLogic } from "../../../../../../logic/AssetManagement/ActionItems/actionItemsEndPointLogic";
import { PriorityOptions } from "../../../../../../constants/PriorityOption";

interface SingleItemCreateProps {
  open: boolean;
  handleClose: () => void;
  selectedSiteFloatingAction?: string;
  selectedDimensionsFloatingAction?: string;
  trackIdFloatingAction?: string;
}

interface ActionItem {
  itemId: number;
  action_item: string | null;
  category: string | null;
  target: string | null;
  priority: string | null;
  due_date: string | null;
  assignee: string | null;
  referTo: string | null;
}

export default function MultipleItemCreate({
  open,
  handleClose,
  selectedSiteFloatingAction, // for floating button
  selectedDimensionsFloatingAction, // for floating button
  trackIdFloatingAction, // for floating button
}: SingleItemCreateProps) {
  const owner = useSelector(selectUserDetails) as any;
  const dimensionFromUser = useSelector(selectUserData)?.data.dimensions;
  const websitePermissions = useSelector(selectUserWebsitePermissions) as any;
  const [selectedValueRadioFilter, setSelectedValueRadioFilter] =
    useState<string>(
      selectedDimensionsFloatingAction ? "Dimension" : "Website"
    );

  const [selectedValueRadioFilterItem, setSelectedValueRadioFilterItem] =
    useState({}) as any;

  // eslint-disable-next-line
  const siteOptions =
    websitePermissions?.map((siteObj: any) => {
      const uid = Object.keys(siteObj)[0]; // UID of the site
      const siteName = siteObj[uid].ui_site_name; // Site name
      const dimensions = siteObj[uid]?.dimensions; // Site name
      return { uid, siteName, dimensions }; // Return as an object with uid and siteName
    }) || [];

  const selectedSiteFromSelector = useSelector(
    (state: any) => state?.actionItems?.selectedSearchSite
  );

  const getSiteSharedUidOnFloatingActionItems = () => {
    if (selectedSiteFloatingAction) {
      return selectedSiteFloatingAction;
    } else if (selectedDimensionsFloatingAction) {
      const item = siteOptions?.find((user: any) =>
        user?.dimensions?.find(
          (value: any) =>
            value?.dimension_name === selectedDimensionsFloatingAction
        )
      );
      return item?.uid;
    }
    return selectedSiteFromSelector;
  };

  // if coming from floating button we will take the selected share uid from there
  const selectedWebsiteSharedUid = getSiteSharedUidOnFloatingActionItems();

  const [defaultreferToValue] = useState(() => {
    if (selectedValueRadioFilter === "Website") {
      if (selectedWebsiteSharedUid) {
        return siteOptions?.find(
          (user: any) => user?.uid === selectedWebsiteSharedUid
        );
      }
    } else if (selectedDimensionsFloatingAction) {
      return dimensionFromUser?.find(
        (dim: any) => dim === selectedDimensionsFloatingAction
      ) as any;
    }
  });

  const [isAssignToChecked, setIsAssignToChecked] = useState(
    selectedSiteFloatingAction || selectedDimensionsFloatingAction
      ? true
      : false
  ) as any;
  const [isDueDateChecked, setIsDueDateChecked] = useState(
    selectedSiteFloatingAction || selectedDimensionsFloatingAction
      ? true
      : false
  ) as any;
  const [isPriorityChecked, setIsPriorityChecked] = useState(
    selectedSiteFloatingAction || selectedDimensionsFloatingAction
      ? true
      : false
  ) as any;
  const [isReferToChecked, setIsReferToChecked] = useState(
    selectedSiteFloatingAction || selectedDimensionsFloatingAction
      ? true
      : false
  ) as any;
  const [checkedValues, setCheckedValues] = useState({
    checkedAssignValue:
      selectedSiteFloatingAction || selectedDimensionsFloatingAction
        ? owner.user_id
        : null,
    checkedDueDateValue:
      selectedSiteFloatingAction || selectedDimensionsFloatingAction
        ? dayjs().add(1, "week").format("YYYY-MM-DD")
        : null,
    checkedPriorityValue:
      selectedSiteFloatingAction || selectedDimensionsFloatingAction
        ? "Medium"
        : null,
    checkedReferToValue: defaultreferToValue ? defaultreferToValue : null,
  });

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const oauthTokenHeader = useSelector(selectUserToken) as string;
  const allUsers = useSelector(selectAllUsers);
  //const allWebsites = useSelector(selectAllWebsites);
  const task_structure_shared_uid = "484362c5f00c4866ad1b4562b47aa27b";
  let currentPath = window.location.origin + location.pathname;

  //-- Generate new action item
  const generateNewActionItem = (id: number): ActionItem => ({
    itemId: id,
    action_item: "",
    category: "",
    target: "",
    priority: "",
    due_date: "",
    assignee: "",
    referTo: "",
  });

  const [actionItemData, setActionItemData] = useState<ActionItem[]>([
    generateNewActionItem(1),
  ]);

  const [formError, setFormError] = useState<any>({});

  // -- Set owner, task_structure_shared_uid and reference id for action item when modal open
  useEffect(() => {
    if (owner?.user_id !== "" && selectedWebsiteSharedUid) {
      setActionItemData((prevState: any[]) =>
        prevState.map((item) => ({
          ...item,
          owner: owner.user_id,
          // reference_id: selectedWebsiteSharedUid,
          task_structure_shared_uid: task_structure_shared_uid,
          // reference_url: `${currentPath}/edit_action_item?selectedSite=${selectedWebsiteSharedUid}`,
        }))
      );
    }
    // eslint-disable-next-line
  }, [open, owner.user_id, selectedWebsiteSharedUid]);

  //-- Add a new action item When clicking on Add Another Button
  const addActionItem = () => {
    setActionItemData((prevData) => [
      ...prevData,
      generateNewActionItem(prevData.length + 1), // Increment itemId
    ]);

    //-- Set value for owner,reference_id and task_structure_shared_uid when adding new action item
    if (owner?.user_id !== "" && selectedWebsiteSharedUid) {
      setActionItemData((prevState: any[]) =>
        prevState.map((item) => ({
          ...item,
          owner: owner.user_id,
          // reference_id: selectedWebsiteSharedUid,
          task_structure_shared_uid: task_structure_shared_uid,
          // reference_url: `${currentPath}/edit_action_item?selectedSite=${selectedWebsiteSharedUid}`,
        }))
      );
    }
  };

  //-- Remove Action Item when clicking on Remove button
  const removeActionItem = (itemId: number) => {
    setActionItemData((prevData) => {
      const newData = prevData.filter((data) => data.itemId !== itemId); // Remove item
      // Re-sequence itemId
      return newData.map((item, index) => ({
        ...item,
        itemId: index + 1, // Recalculate itemId based on index
      }));
    });
  };

  //-- set the value on change whenever any field value is changed
  const handleActionItemChange = (
    itemId: number,
    name: keyof ActionItem,
    value: any
  ) => {
    setActionItemData((prevData) =>
      prevData.map((item) =>
        item.itemId === itemId ? { ...item, [name]: value } : item
      )
    );

    const validationRules: Record<string, (val: any) => string> = {
      action_item: validateActionItemName,
      category: validateText,
      target: validateText,
      description: validateText,
      due_date: validateDateFormat,
      assignee: isEmpty,
      priority: isEmpty,
      referTo: isEmpty,
    };

    const errorMsg = validationRules[name]?.(value) || "";

    setFormError((prevErrors: any) => {
      const newErrors = { ...prevErrors };

      // Ensure the object for the specific `itemId` exists
      if (!newErrors[itemId]) {
        newErrors[itemId] = {};
      }

      // Set or remove field error for the specific itemId
      if (errorMsg) {
        newErrors[itemId][name] = errorMsg;
      } else {
        delete newErrors[itemId][name];
      }

      // Ensure errors are removed when checkboxes are unchecked
      if (!isAssignToChecked) delete newErrors["checkedAssignValue"];
      if (!isDueDateChecked) delete newErrors["checkedDueDateValue"];
      if (!isPriorityChecked) delete newErrors["checkedPriorityValue"];
      if (!isReferToChecked) delete newErrors["checkedReferToValue"];

      return newErrors;
    });
  };

  //-- Set the value on change whenever any checkbox-related field is updated
  const handleCheckedValueChange = (name: string, value: any) => {
    setCheckedValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormError((prevErrors: any) => {
      const newErrors = { ...prevErrors };

      // Validate the field only if its corresponding checkbox is checked
      const isChecked =
        (name === "checkedAssignValue" && isAssignToChecked) ||
        (name === "checkedDueDateValue" && isDueDateChecked) ||
        (name === "checkedPriorityValue" && isPriorityChecked) ||
        (name === "checkedReferToValue" && isReferToChecked);

      if (isChecked) {
        newErrors[name] = validateField(name, value);
      } else {
        delete newErrors[name]; // Remove error when checkbox is unchecked
      }

      if (!isAssignToChecked) delete newErrors["checkedAssignValue"];
      if (!isDueDateChecked) delete newErrors["checkedDueDateValue"];
      if (!isPriorityChecked) delete newErrors["checkedPriorityValue"];
      if (!isReferToChecked) delete newErrors["checkedReferToValue"];

      return newErrors;
    });
  };

  // Validation function
  const validateField = (name: string, value: any) => {
    const validationRules: Record<string, (val: any) => string> = {
      checkedAssignValue: isEmpty,
      checkedDueDateValue: validateDateFormat,
      checkedPriorityValue: isEmpty,
      checkedReferToValue: isEmpty,
    };

    return validationRules[name]?.(value) || "";
  };

  //-- this for button disabled/enabled if form is valid and error fields are empty
  const isFormValid = () => {
    // Check if there are any errors in formError (all values must be falsy)
    const hasNoErrors = Object.values(formError).every((err) => !err);

    // Validate each action item
    const areActionItemsValid = actionItemData.every((item) => {
      return Object.entries(item).every(([key, value]) => {
        // Skip validation if the checkbox is unchecked
        if (key === "checkedAssignValue" && !isAssignToChecked) return true;
        if (key === "checkedDueDateValue" && !isDueDateChecked) return true;
        if (key === "checkedPriorityValue" && !isPriorityChecked) return true;
        if (key === "checkedReferToValue" && !isReferToChecked) return true;

        // Skip validation for(assignee, due_date, priority) if the checkbox is checked for(checkedAssignValue, checkedDueDateValue, checkedPriorityValue)
        if (key === "assignee" && isAssignToChecked) return true;
        if (key === "due_date" && isDueDateChecked) return true;
        if (key === "priority" && isPriorityChecked) return true;
        if (key === "referTo" && isReferToChecked) return true;

        // Ensure fields are not null, undefined, or empty
        return (
          value !== null &&
          value !== undefined &&
          value.toString().trim() !== ""
        );
      });
    });

    //-- if checkboxes are checked but related field values are null return false
    if (isAssignToChecked && checkedValues.checkedAssignValue === null)
      return false;
    if (isDueDateChecked && checkedValues.checkedDueDateValue === null)
      return false;
    if (isPriorityChecked && checkedValues.checkedPriorityValue === null)
      return false;
    if (isReferToChecked && checkedValues.checkedReferToValue === null)
      return false;

    return !hasNoErrors && areActionItemsValid;
  };

  //-- if checkboxes are checked then set each assignee, due_date, priority to "" and form error for each field to ""
  useEffect(() => {
    if (isAssignToChecked) {
      setActionItemData((prev) =>
        prev.map((item: any) => ({ ...item, assignee: "" }))
      );
      setFormError((prev: any) => ({ ...prev, assignee: "" }));
    } else {
      setCheckedValues((prev) => ({ ...prev, checkedAssignValue: null }));
    }
    if (isDueDateChecked) {
      setActionItemData((prev) =>
        prev.map((item: any) => ({ ...item, due_date: "" }))
      );
      setFormError((prev: any) => ({ ...prev, due_date: "" }));
    } else {
      setCheckedValues((prev) => ({ ...prev, checkedDueDateValue: null }));
    }
    if (isPriorityChecked) {
      setActionItemData((prev) =>
        prev.map((item: any) => ({ ...item, priority: "" }))
      );
      setFormError((prev: any) => ({ ...prev, priority: "" }));
    } else {
      setCheckedValues((prev) => ({ ...prev, checkedPriorityValue: null }));
    }
    if (isReferToChecked) {
      setActionItemData((prev) =>
        prev.map((item: any) => ({ ...item, referTo: "" }))
      );
      setFormError((prev: any) => ({ ...prev, referTo: "" }));
    } else {
      setCheckedValues((prev) => ({ ...prev, checkedReferToValue: null }));
    }
  }, [
    isAssignToChecked,
    isDueDateChecked,
    isPriorityChecked,
    isReferToChecked,
    actionItemData?.length,
  ]);

  //-- close the modal and reset the modal data
  const handleCloseItemModal = () => {
    handleClose(); // close the modal to create new action item
    setActionItemData([generateNewActionItem(1)]); // Reset modal data to initial state
    setFormError({}); // reset form errors
    if (isAssignToChecked) {
      setIsAssignToChecked(false); // Reset checkbox
      setCheckedValues({ ...checkedValues, checkedAssignValue: null }); // Reset checkbox related field value
    }
    if (isPriorityChecked) {
      setIsPriorityChecked(false); // Reset checkbox
      setCheckedValues({ ...checkedValues, checkedPriorityValue: null }); // Reset checkbox related field value
    }
    if (isReferToChecked) {
      setIsReferToChecked(false); // Reset checkbox
      setCheckedValues({ ...checkedValues, checkedReferToValue: null }); // Reset checkbox related field value
    }
    if (isDueDateChecked) {
      setIsDueDateChecked(false); // Reset checkbox
      setCheckedValues({ ...checkedValues, checkedDueDateValue: null }); // Reset checkbox related field value
    }
  };

  const getSegmentValueItem = (value: any, segmentType: string) => {
    if (segmentType === "Website") {
      return value?.referTo?.uid;
    } else {
      let segmentValue = siteOptions?.find((user: any) =>
        user?.dimensions.find(
          (dimesion: any) => dimesion?.dimension_name === value?.referTo
        )
      );

      return segmentValue?.dimensions.find(
        (dimension: any) => dimension?.dimension_name === value?.referTo
      )?.dimension_shared_uid;
    }
  };

  const getWebstieSharedUidForItem = (value: any, segmentType: string) => {
    if (segmentType === "Website") {
      return value?.referTo?.uid;
    } else {
      return siteOptions?.find((user: any) =>
        user?.dimensions.find(
          (dimension: any) => dimension?.dimension_name === value?.referTo
        )
      )?.uid;
    }
  };

  //-- Request body for creating multiple action items
  const multiTaskRequestBody = (
    updatedReferToValue: any,
    segmentValue: any
  ) => {
    return {
      tasks: actionItemData?.map((item: any) => ({
        task_structure_shared_uid: isReferToChecked
          ? task_structure_shared_uid
          : item?.task_structure_shared_uid,
        owner: item?.owner,
        assignee: isAssignToChecked
          ? checkedValues.checkedAssignValue
          : item?.assignee,
        reference_id: isReferToChecked
          ? updatedReferToValue?.uid
          : getWebstieSharedUidForItem(
              item,
              selectedValueRadioFilterItem[item?.itemId]
            ),
        due_date: isDueDateChecked
          ? checkedValues.checkedDueDateValue
          : item?.due_date,
        segment_type: isReferToChecked
          ? selectedValueRadioFilter.toLowerCase()
          : selectedValueRadioFilterItem[item?.itemId].toLowerCase(),
        segment_value: isReferToChecked
          ? segmentValue
          : getSegmentValueItem(
              item,
              selectedValueRadioFilterItem[item?.itemId]
            ),
        website_shared_uid: isReferToChecked
          ? updatedReferToValue?.uid
          : getWebstieSharedUidForItem(
              item,
              selectedValueRadioFilterItem[item?.itemId]
            ),
        reference_url: `${currentPath}/edit_action_item?selectedSite=${
          isReferToChecked
            ? updatedReferToValue?.uid
            : getWebstieSharedUidForItem(
                item,
                selectedValueRadioFilterItem[item?.itemId]
              )
        }`,
        data: {
          category: item?.category,
          target: item?.target,
          priority: isPriorityChecked
            ? checkedValues.checkedPriorityValue
            : item?.priority,
          action_item: item?.action_item,
        },
      })),
    };
  };

  //-- Clicking on button to create single/multiple new action items
  const handleCreateMultipleActionItem = async () => {
    if (!isFormValid() || actionItemData?.length === 0) return;

    let updatedReferToValue = checkedValues.checkedReferToValue;
    let segmentValue = updatedReferToValue?.uid as any;
    if (selectedValueRadioFilter === "Dimension") {
      updatedReferToValue = siteOptions?.find((user: any) =>
        user?.dimensions?.find(
          (value: any) =>
            value?.dimension_name === checkedValues.checkedReferToValue
        )
      );
      segmentValue = updatedReferToValue?.dimensions.find(
        (value: any) =>
          value?.dimension_name === checkedValues.checkedReferToValue
      )?.dimension_shared_uid;
    }

    setLoading(true);
    try {
      const res = await ActionItemsEndPointLogic.CreateNewActionItem(
        oauthTokenHeader,
        multiTaskRequestBody(updatedReferToValue, segmentValue)
      );

      if (res?.reason !== "success") {
        throw new Error(`Failed to Create new task.`);
      }
      //  Extract updated tasks from the response(those have created are true)
      const updatedTasks =
        res?.data?.filter((create: any) => create.created) || [];

      if (updatedTasks.length === 0) {
        throw new Error("No tasks were created.");
      }

      handleCloseItemModal();
      dispatch(
        setDisplayErrorSnackBar({
          message: "Action item has been created successfully.",
          type: "success",
        })
      );

      if (!selectedSiteFloatingAction && !selectedDimensionsFloatingAction) {
        // Fetch updated action items and reset modal data
        await ActionItemsEndPointLogic.getAllActionItems(
          selectedWebsiteSharedUid,
          oauthTokenHeader,
          dispatch
        );
        navigate(`/tools/action_items${location.search}`); // Redirect to the Action Items List
      }
    } catch (error) {
      // Ensure error message is a string
      const errorMessage =
        typeof error === "string"
          ? error
          : error instanceof Error
          ? error.message
          : "An unexpected error occurred.";

      dispatch(
        setDisplayErrorSnackBar({
          message: `Failed to Create new task. ${errorMessage}`,
          type: "error",
        })
      );
      return; // Stop execution, do not close modal
    } finally {
      setLoading(false);
    }
  };

  //-- Get Users
  useEffect(() => {
    ActionItemsEndPointLogic.getAllUserList(oauthTokenHeader);
    //ActionItemsEndPointLogic.getAllWebsites(oauthTokenHeader);
  }, [oauthTokenHeader]);

  const handleChangeRadioFilter = (event: any) => {
    setSelectedValueRadioFilter(event.target.value);
    setCheckedValues((prev) => ({ ...prev, checkedReferToValue: null }));
  };

  const handleChangeRadioFilterItem = (itemid: any) => (event: any) => {
    setSelectedValueRadioFilterItem((prev: any) => ({
      ...prev,
      [itemid]: event.target.value,
    }));
  };

  const getSelectedType = () => {
    if (selectedDimensionsFloatingAction) {
      setSelectedValueRadioFilter("Dimension");
    } else {
      setSelectedValueRadioFilter("Website");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        // Prevent close if loading and the reason is backdrop click or escape key
        if (
          loading &&
          (reason === "backdropClick" || reason === "escapeKeyDown")
        ) {
          return;
        }
        handleCloseItemModal();
      }}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle sx={{ padding: "16px 24px 0px 24px" }}>
        {"Add New Items"}
      </DialogTitle>
      <DialogContent
        sx={{ padding: "16px 24px", paddingTop: "16px !Important" }}
      >
        <Typography>Details</Typography>
        <Grid container spacing={2} flexDirection={"column"}>
          <Grid size={6} display="flex" alignItems="center" gap={2}>
            <Box minWidth="140px">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAssignToChecked}
                    onChange={(e) => setIsAssignToChecked(e.target.checked)}
                    color="secondary"
                  />
                }
                label="Assign all to"
              />
            </Box>
            <Autocomplete
              defaultValue={selectedSiteFloatingAction ? owner : ""}
              disablePortal={false}
              options={allUsers}
              disabled={!isAssignToChecked}
              getOptionLabel={(option) =>
                `${option?.first_name || ""} ${option?.last_name || ""}`
              } // Display name correctly
              value={
                allUsers?.find(
                  (user: any) => user?.id === checkedValues?.checkedAssignValue
                ) || null
              }
              onChange={(_, newValue) =>
                handleCheckedValueChange(
                  "checkedAssignValue",
                  newValue?.id || null
                )
              }
              fullWidth
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.first_name} {option.last_name}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Assignee"
                  size="small"
                  required={isAssignToChecked}
                  error={Boolean(
                    isAssignToChecked && formError?.checkedAssignValue
                  )} //Error is only shown when isAssignToChecked is true AND formError has a value.
                  helperText={
                    isAssignToChecked ? formError?.checkedAssignValue || "" : ""
                  } //Helper text disappears when the checkbox is unchecked.
                  color="secondary"
                  placeholder="Choose Stakeholder from the list"
                  sx={{ input: { cursor: "pointer" } }} // show pointer on hover
                  onKeyDown={(e) => e.preventDefault()} // Blocks manual typing
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </Grid>

          <Grid size={6} display="flex" alignItems="center" gap={2}>
            <Box minWidth="140px">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isDueDateChecked}
                    onChange={(e) => setIsDueDateChecked(e.target.checked)}
                    color="secondary"
                  />
                }
                label="Set all to"
              />
            </Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Due Date"
                disabled={!isDueDateChecked}
                value={
                  checkedValues?.checkedDueDateValue
                    ? dayjs(checkedValues.checkedDueDateValue)
                    : null
                } // Ensure selected date is displayed
                slotProps={{
                  textField: {
                    fullWidth: true,
                    required: isDueDateChecked,
                    error: Boolean(
                      isDueDateChecked && formError?.checkedDueDateValue
                    ), //Error is only shown when isAssignToChecked is true AND formError has a value.
                    helperText: isDueDateChecked
                      ? formError?.checkedDueDateValue || ""
                      : "", //Helper text disappears when the checkbox is unchecked.
                    size: "small",
                    color: "secondary",
                    InputLabelProps: { shrink: true },
                    placeholder: "Set Date",
                    inputProps: {
                      readOnly: true,
                      onKeyDown: (e) => {
                        // Block ALL keys including numbers and delete
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      },
                      onKeyPress: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      },
                      onKeyUp: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      },
                      onInput: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      },
                      onBeforeInput: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      },
                      onPaste: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      },
                      onCut: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      },
                      onChange: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                      },
                      onFocus: (e) => {
                        e.target.blur(); // Remove focus immediately
                      },
                      style: {
                        pointerEvents: "none",
                        caretColor: "transparent",
                        userSelect: "none",
                        WebkitUserSelect: "none",
                        MozUserSelect: "none",
                        cursor: "default",
                      },
                    },
                    sx: {
                      "& .MuiInputBase-input": {
                        pointerEvents: "none !important",
                        caretColor: "transparent !important",
                        userSelect: "none !important",
                        WebkitUserSelect: "none !important",
                        MozUserSelect: "none !important",
                        "&:focus": {
                          outline: "none !important",
                          boxShadow: "none !important",
                        },
                      },
                      "& .MuiIconButton-root": {
                        pointerEvents: "auto !important",
                        cursor: "pointer !important",
                      },
                    },
                  },
                }}
                format="DD/MM/YYYY"
                minDate={dayjs()} // Prevent selection of past dates
                disablePast // Disables all past dates automatically
                onChange={(date) => {
                  if (date) {
                    handleCheckedValueChange(
                      "checkedDueDateValue",
                      dayjs(date).format("YYYY-MM-DD")
                    );
                  } else {
                    handleCheckedValueChange("checkedDueDateValue", ""); // Reset value if date is cleared
                  }
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid size={6} display="flex" alignItems="center" gap={2}>
            <Box minWidth="140px">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isPriorityChecked}
                    onChange={(e) => setIsPriorityChecked(e.target.checked)}
                    color="secondary"
                  />
                }
                label="Mark all as"
              />
            </Box>
            <Autocomplete
              disabled={!isPriorityChecked}
              options={PriorityOptions}
              fullWidth
              getOptionLabel={(option) => option?.label}
              value={
                PriorityOptions.find(
                  (opt) => opt.label === checkedValues?.checkedPriorityValue
                ) || null
              }
              onChange={(_, newValue: any) =>
                handleCheckedValueChange(
                  "checkedPriorityValue",
                  newValue?.label || null
                )
              }
              renderOption={(props, option) => (
                <ListItem {...props} key={option.label}>
                  <ListItemIcon>{option.icon}</ListItemIcon>
                  <ListItemText primary={option.label} />
                </ListItem>
              )}
              renderInput={(params) => {
                // Find the selected option to show the correct icon
                const selectedOption = PriorityOptions.find(
                  (opt) => opt.label === params.inputProps.value
                );
                return (
                  <TextField
                    {...params}
                    label="Priority"
                    size="small"
                    color="secondary"
                    required={isPriorityChecked}
                    error={Boolean(
                      isPriorityChecked && formError?.checkedPriorityValue
                    )} //Error is only shown when isAssignToChecked is true AND formError has a value.
                    helperText={
                      isPriorityChecked
                        ? formError?.checkedPriorityValue || ""
                        : ""
                    } //Helper text disappears when the checkbox is unchecked.
                    placeholder="Choose from the list."
                    inputProps={{
                      ...params.inputProps,
                      sx: { cursor: "pointer" },
                    }} // Ensures dropdown opens
                    onKeyDown={(e) => e.preventDefault()} // Blocks manual typing
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: selectedOption ? (
                        <InputAdornment position="start">
                          {selectedOption.icon}
                        </InputAdornment>
                      ) : null,
                    }}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                );
              }}
            />
          </Grid>
        </Grid>

        <Grid size={2} display="flex" alignItems="center" gap={2} mt={2}>
          <Box minWidth="140px">
            <FormControlLabel
              control={
                <Checkbox
                  checked={isReferToChecked}
                  onChange={(e) => setIsReferToChecked(e.target.checked)}
                  color="secondary"
                />
              }
              label="All refer to:"
            />
          </Box>
          <RadioGroup
            value={
              selectedValueRadioFilter
                ? selectedValueRadioFilter
                : getSelectedType()
            }
            onChange={handleChangeRadioFilter}
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <Stack direction="row">
              <FormControlLabel
                value="Website"
                control={
                  <Radio color="secondary" size="small" defaultChecked />
                }
                label="Website"
              />
              <FormControlLabel
                value="Dimension"
                control={<Radio color="secondary" size="small" />}
                label="Dimension"
              />
            </Stack>
          </RadioGroup>
          <Autocomplete
            onChange={(_, newValue: any) =>
              handleCheckedValueChange("checkedReferToValue", newValue || null)
            }
            onError={
              Boolean(isReferToChecked && formError?.checkedReferToValue) as any
            } //Error is only shown when isAssignToChecked is true AND formError has a value.
            // defaultValue={getDefaultValue()}
            disablePortal={false}
            options={
              selectedValueRadioFilter === "Website"
                ? (siteOptions as any)
                : (dimensionFromUser as any)
            }
            getOptionLabel={
              selectedValueRadioFilter === "Website"
                ? (option) => `${option?.siteName}`
                : (option) => `${option}`
            } // Display name correctly
            value={checkedValues.checkedReferToValue}
            fullWidth
            renderOption={(props, option) => (
              <li {...props} key={option?.siteName || option}>
                {selectedValueRadioFilter === "Website"
                  ? option?.siteName
                  : option}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Website or dimension"
                size="small"
                color="secondary"
                sx={{ input: { cursor: "pointer" } }} // show pointer on hover
              />
            )}
          />
        </Grid>

        {/* This for when three checkboxes are selected then this part will visible */}
        {/* Action Item Fields when clicked */}
        <Grid
          container
          spacing={2}
          mt={2}
          display={
            isAssignToChecked &&
            isDueDateChecked &&
            isPriorityChecked &&
            isReferToChecked
              ? "flex"
              : "none"
          }
        >
          {/* Action Item Title */}
          {actionItemData?.map((item: any, index: any) => (
            <Grid container key={item?.itemId}>
              <Grid size={12}>
                <Typography>Action Item #{index + 1}</Typography>
              </Grid>
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Action Item Name"
                  size="small"
                  color="secondary"
                  placeholder="Name this task"
                  required
                  value={item?.action_item}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleActionItemChange(
                      item?.itemId,
                      "action_item",
                      e.target.value
                    )
                  }
                  error={formError[item.itemId]?.action_item}
                  helperText={formError[item.itemId]?.action_item}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Category"
                  size="small"
                  color="secondary"
                  placeholder="This item relates to"
                  required
                  value={item?.category}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleActionItemChange(
                      item?.itemId,
                      "category",
                      e.target.value
                    )
                  }
                  error={formError[item.itemId]?.category}
                  helperText={formError[item.itemId]?.category}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Target"
                  size="small"
                  required
                  color="secondary"
                  placeholder="Specify your target for this item"
                  value={item?.target}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleActionItemChange(
                      item?.itemId,
                      "target",
                      e.target.value
                    )
                  }
                  error={formError[item.itemId]?.target}
                  helperText={formError[item.itemId]?.target}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid>
              {item?.itemId > 1 && (
                <Grid size={3}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    onClick={() => removeActionItem(item?.itemId)}
                  >
                    <Stack direction="row" alignItems="initial" gap={1}>
                      Remove Task <DeleteIcon fontSize="small" />
                    </Stack>
                  </Button>
                </Grid>
              )}
            </Grid>
          ))}
          <Grid size={3}>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={addActionItem}
            >
              <Stack direction="row" alignItems="initial" gap={1}>
                Add another <AddIcon fontSize="small" />
              </Stack>
            </Button>
          </Grid>
        </Grid>

        {/* This applies when no checkbox is selected or when one or two checkboxes are selected.*/}
        {/* Action Item Fields when not clicked */}
        <Grid
          container
          spacing={2}
          mt={2}
          display={
            !isAssignToChecked ||
            !isDueDateChecked ||
            !isPriorityChecked ||
            !isReferToChecked
              ? "flex"
              : "none"
          }
        >
          {/* Action Item Title */}
          {/* <Grid size={12}>
            <Typography>Action Item #2</Typography>
          </Grid> */}
          {actionItemData?.map((item: any) => (
            <Grid container key={item.itemId}>
              <Grid size={12}>
                {" "}
                <Typography>Action Item #{item.itemId}</Typography>{" "}
              </Grid>
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Action Item Name"
                  size="small"
                  color="secondary"
                  placeholder="Name this task"
                  required
                  value={item?.action_item}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleActionItemChange(
                      item?.itemId,
                      "action_item",
                      e.target.value
                    )
                  }
                  error={formError[item.itemId]?.action_item}
                  helperText={formError[item.itemId]?.action_item}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Category"
                  size="small"
                  color="secondary"
                  placeholder="This item relates to"
                  required
                  value={item?.category}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleActionItemChange(
                      item?.itemId,
                      "category",
                      e.target.value
                    )
                  }
                  error={formError[item.itemId]?.category}
                  helperText={formError[item.itemId]?.category}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Target"
                  size="small"
                  required
                  color="secondary"
                  placeholder="Specify your target for this item"
                  value={item?.target}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleActionItemChange(
                      item?.itemId,
                      "target",
                      e.target.value
                    )
                  }
                  error={formError[item.itemId]?.target}
                  helperText={formError[item.itemId]?.target}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid>

              {!isDueDateChecked && (
                <Grid size={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Due Date"
                      slotProps={{
                        textField: {
                          required: true,
                          fullWidth: true,
                          error: !!formError[item.itemId]?.due_date,
                          helperText: formError[item.itemId]?.due_date || "",
                          size: "small",
                          color: "secondary",
                          InputLabelProps: { shrink: true },
                          placeholder: "Set Date",
                          inputProps: {
                            readOnly: true,
                            onKeyDown: (e) => {
                              // Block ALL keys including numbers and delete
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            },
                            onKeyPress: (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            },
                            onKeyUp: (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            },
                            onInput: (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            },
                            onBeforeInput: (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            },
                            onPaste: (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            },
                            onCut: (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            },
                            onChange: (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            },
                            onFocus: (e) => {
                              e.target.blur(); // Remove focus immediately
                            },
                            style: {
                              pointerEvents: "none",
                              caretColor: "transparent",
                              userSelect: "none",
                              WebkitUserSelect: "none",
                              MozUserSelect: "none",
                              cursor: "default",
                            },
                          },
                          sx: {
                            "& .MuiInputBase-input": {
                              pointerEvents: "none !important",
                              caretColor: "transparent !important",
                              userSelect: "none !important",
                              WebkitUserSelect: "none !important",
                              MozUserSelect: "none !important",
                              "&:focus": {
                                outline: "none !important",
                                boxShadow: "none !important",
                              },
                            },
                            "& .MuiIconButton-root": {
                              pointerEvents: "auto !important",
                              cursor: "pointer !important",
                            },
                          },
                        },
                      }}
                      format="DD/MM/YYYY"
                      minDate={dayjs()} // Prevent selection of past dates
                      disablePast // Disables all past dates automatically
                      onChange={(date) => {
                        if (date)
                          handleActionItemChange(
                            item?.itemId,
                            "due_date",
                            dayjs(date).format("YYYY-MM-DD")
                          );
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              )}

              {!isAssignToChecked && (
                <Grid size={6}>
                  <Autocomplete
                    disablePortal={false}
                    options={allUsers}
                    getOptionLabel={(option) =>
                      `${option?.first_name || ""} ${option?.last_name || ""}`
                    } // Display name correctly
                    value={
                      allUsers?.find(
                        (user: any) => user?.id === item?.assignee
                      ) || null
                    }
                    onChange={(_, newValue) =>
                      handleActionItemChange(
                        item?.itemId,
                        "assignee",
                        newValue?.id || null
                      )
                    }
                    fullWidth
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.first_name} {option.last_name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Assignee"
                        size="small"
                        required
                        error={formError[item.itemId]?.assignee}
                        helperText={formError[item.itemId]?.assignee}
                        color="secondary"
                        placeholder="Choose Stakeholder from the list"
                        sx={{ input: { cursor: "pointer" } }} // show pointer on hover
                        onKeyDown={(e) => e.preventDefault()} // Blocks manual typing
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
              )}
              {!isPriorityChecked && (
                <Grid size={6}>
                  <Autocomplete
                    fullWidth
                    options={PriorityOptions}
                    getOptionLabel={(option) => option.label}
                    value={
                      PriorityOptions.find(
                        (opt) => opt.label === item?.priority
                      ) || null
                    }
                    onChange={(_, newValue: any) =>
                      handleActionItemChange(
                        item?.itemId,
                        "priority",
                        newValue?.label || null
                      )
                    }
                    renderOption={(props, option) => (
                      <ListItem {...props} key={option.label}>
                        <ListItemIcon>{option.icon}</ListItemIcon>
                        <ListItemText primary={option.label} />
                      </ListItem>
                    )}
                    renderInput={(params) => {
                      // Find the selected option to show the correct icon
                      const selectedOption = PriorityOptions.find(
                        (opt: any) => opt.label === params.inputProps.value
                      );
                      return (
                        <TextField
                          {...params}
                          label="Priority"
                          size="small"
                          color="secondary"
                          required
                          error={formError[item.itemId]?.priority}
                          helperText={formError[item.itemId]?.priority}
                          placeholder="Choose from the list."
                          inputProps={{
                            ...params.inputProps,
                            sx: { cursor: "pointer" },
                          }} // Ensures dropdown opens
                          onKeyDown={(e) => e.preventDefault()} // Blocks manual typing
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: selectedOption ? (
                              <InputAdornment position="start">
                                {selectedOption.icon}
                              </InputAdornment>
                            ) : null,
                          }}
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            },
                          }}
                        />
                      );
                    }}
                  />
                </Grid>
              )}

              {!isReferToChecked && (
                <Grid
                  size={12}
                  display="flex"
                  alignItems="center"
                  gap={4}
                  mt={2}
                >
                  <label style={{ minWidth: "64px"}}>Refer to:</label>
                  <RadioGroup
                    value={
                      selectedValueRadioFilterItem[item?.itemId]
                        ? selectedValueRadioFilterItem[item?.itemId]
                        : null
                    }
                    onChange={handleChangeRadioFilterItem(item?.itemId)}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <Stack direction="row">
                      <FormControlLabel
                        value="Website"
                        control={
                          <Radio
                            color="secondary"
                            size="small"
                            defaultChecked
                          />
                        }
                        label="Website"
                      />
                      <FormControlLabel
                        value="Dimension"
                        control={<Radio color="secondary" size="small" />}
                        label="Dimension"
                      />
                    </Stack>
                  </RadioGroup>
                  <Autocomplete
                    disabled={
                      selectedValueRadioFilterItem[item?.itemId] ? false : true
                    }
                    fullWidth
                    onChange={(_, newValue: any) =>
                      handleActionItemChange(
                        item?.itemId,
                        "referTo",
                        newValue || null
                      )
                    }
                    disablePortal={false}
                    options={
                      selectedValueRadioFilterItem[item?.itemId] === "Dimension"
                        ? (dimensionFromUser as any)
                        : (siteOptions as any)
                    }
                    getOptionLabel={
                      selectedValueRadioFilterItem[item?.itemId] === "Dimension"
                        ? (option) => `${option}`
                        : (option) => `${option?.siteName}`
                    } // Display name correctly
                    value={item?.referTO}
                    renderOption={(props, option) => (
                      <li {...props} key={option?.siteName || option}>
                        {selectedValueRadioFilterItem[item?.itemId] ===
                        "Dimension"
                          ? option
                          : option?.siteName}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Website or dimension"
                        size="small"
                        color="secondary"
                        sx={{ input: { cursor: "pointer" } }} // show pointer on hover
                      />
                    )}
                  />
                </Grid>
              )}

              {item?.itemId > 1 && (
                <Grid size={12} display="flex" justifyContent="flex-end">
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => removeActionItem(item?.itemId)}
                    sx={{ width: "192px" }}
                    endIcon={<DeleteIcon fontSize="small" />}
                  >
                    Remove Task
                  </Button>
                </Grid>
              )}
              <Divider />
            </Grid>
          ))}
          <Grid size={3}>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={addActionItem}
            >
              <Stack direction="row" alignItems="initial" gap={1}>
                Add another <AddIcon fontSize="small" />
              </Stack>
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ padding: "0px 24px 24px 24px" }}>
        <Button
          color="secondary"
          onClick={handleCloseItemModal}
          disabled={loading}
        >
          CANCEL
        </Button>
        <Button
          data-tracker={trackIdFloatingAction ? trackIdFloatingAction : "124"}
          color="secondary"
          variant="contained"
          loading={loading}
          loadingPosition="end"
          endIcon={loading && <SaveIcon />}
          disabled={!isFormValid()}
          onClick={handleCreateMultipleActionItem}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
            gap={1}
          >
            ADD Action Item <CheckIcon fontSize="small" />
          </Stack>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
